module.exports = __webpack_public_path__ + "img/img_blank_coupon_park.c7a6926b.png";